__turbopack_context__.v({
  "editView": "InvestorProfileDetails-module-scss-module__EIicdW__editView",
  "root": "InvestorProfileDetails-module-scss-module__EIicdW__root",
});
